
import server from '../../public/server/server'
const xlSasApi = {
    //----------------------事件受理-----------------------------------
    findAllByAreaId:server.visualIntercom +  '/alarm/findAllByAreaId', // 列表
    queryAlarmCount:server.visualIntercom +  '/alarm/queryAlarmCount', // 图表
    //----------------------用户发展-----------------------------------
	queryStatistics:server.requestPath+'/queryStatistics',//列表
	statistics:server.requestPath+'/statistics',//图表
    //----------------------信息发布-----------------------------------
	queryStatisticsMsg:server.requestPath+'/queryStatisticsMsg',//列表
	statisticsMsg:server.requestPath+'/statisticsMsg',//图表
}

export {
	xlSasApi
}
